import { AccessorColumnHelper, accessor } from "./accessor"
import { ActiveColumnHelper, active } from "./active"
import { AddressColumnHelper, address } from "./address"
import { DataColumnHelper, data } from "./data"
import { DateColumnHelper, date } from "./date"
import { DecimalQuantityColumnHelper, decimalQuantity } from "./decimalQuantity"
import { EmailColumnHelper, email } from "./email"
import { FractionalMoneyColumnHelper, fractionalMoney } from "./fractionalMoney"
import { GroupColumnHelper, group } from "./group"
import { IdColumnHelper, id } from "./id"
import { IntegerColumnHelper, integer } from "./integer"
import { LocationColumnHelper, location } from "./location"
import { MoneyColumnHelper, money } from "./money"
import { NotesColumnHelper, notes } from "./notes"
import { PercentColumnHelper, percent } from "./percent"
import { PhoneColumnHelper, phone } from "./phone"
import { TagColumnHelper, tag } from "./tag"
import { TagsColumnHelper, tags } from "./tags"
import { TimestampColumnHelper, timestamp } from "./timestamp"
import { TimestampRangeColumnHelper, timestampRange } from "./timestampRange"
import { UserColumnHelper, user } from "./user"

interface ColumnHelper<T> {
  group: GroupColumnHelper<T>
  data: DataColumnHelper<T>
  accessor: AccessorColumnHelper<T>
  phone: PhoneColumnHelper<T>
  email: EmailColumnHelper<T>
  address: AddressColumnHelper<T>
  active: ActiveColumnHelper<T>
  notes: NotesColumnHelper<T>
  id: IdColumnHelper<T>
  money: MoneyColumnHelper<T>
  fractionalMoney: FractionalMoneyColumnHelper<T>
  percent: PercentColumnHelper<T>
  decimalQuantity: DecimalQuantityColumnHelper<T>
  tag: TagColumnHelper<T>
  tags: TagsColumnHelper<T>
  timestamp: TimestampColumnHelper<T>
  timestampRange: TimestampRangeColumnHelper<T>
  integer: IntegerColumnHelper<T>
  location: LocationColumnHelper<T>
  user: UserColumnHelper<T>
  date: DateColumnHelper<T>
}

export function createColumnHelper<T>(): ColumnHelper<T> {
  return {
    group,
    data,
    accessor,
    phone,
    email,
    address,
    active,
    notes,
    id,
    money,
    fractionalMoney,
    percent,
    decimalQuantity,
    tag,
    tags,
    timestamp,
    timestampRange,
    integer,
    location,
    user,
    date,
  }
}
